import { useState, useEffect, useMemo, useCallback, useRef, useLayoutEffect } from 'react';
import { Link, useParams, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Button, Layout, Table, Space, Form, Input, Modal, message, Typography, Select, Row, Col, Tooltip, Alert, Upload, Image, TreeSelect } from 'antd';
import { useHorizontalScrollGuard } from '@/hooks/useHorizontalScrollGuard';
import { useFilterPanelVisible } from '@/hooks/useFilterPanelVisible';
import { useTableScrollY } from '@/hooks/useTableScrollY';
import { useVerticalScrollShadow } from '@/hooks/useVerticalScrollShadow';
import { laborFeeListApi, statisticalAmountApi, updateLaborFeeApi, sendAgendaConfirmTaskApi, savelaborFeeJoinCertApi, laborFeeRequestBatchesListApi, laborFeeBatchApplyApi, exportExpertLaborFeeDownloadV2Api } from '@services/SereviseConst';
import { conferenceOnceApi, setLaborFeeDemandRemarkApi } from '@services/Conference';
import { getConferenceListApi } from '@services/Agenda';
import { TABLE_PAGE_SIZE_OPTIONS, filterFormGridLayout } from '@utils/property';
import { localStorageGet } from '@core/cookie';
import { convertDateTimeToLocalText, prepareBCOSSUrl, buildAuthDictMaps, formatOfficeAndPost, getAdminInfo, numberProject } from '@utils/utils';
import { filterTreeNodeByTitle } from '@/utils/antdTreeSelect';
import { laborFeeCostBearers, expertLevels, cardTypes, CurrencyList } from '@utils/constants';
import { fileApi } from '@services/Conference';
import { CONFERENCE_WORKSPACE_PARENT_PATH, CONFERENCE_WORKSPACE_ROUTE_BASE } from '@/layouts/conferenceWorkspaceConfig';
import './index.less';
import { conferenceActions } from '../store/conferenceSlice';
import dayjs from 'dayjs';
import { pageFormItemLayout } from '@utils/property';
import ChooseExpertModal from './components/ChooseExpertModal';
import ConfirmScheduleModal from './components/ConfirmScheduleModal';
import ConfirmBankInfoModal from './components/ConfirmBankInfoModal';
import PaymentBatchDrawer from './components/PaymentBatchDrawer';
import { authdictionaryApi } from '@services/Conference/sign';
import { isEmpty } from 'lodash';
import ExpertInfoCard from '@/components/common/ExpertInfoCard';
import GuestTaskList from '@/components/common/GuestTaskList';
import { logSendLaborFeeConfirmationTask } from '@/utils/laborFeeLogger';
import OperationLogDrawer from '@/components/common/OperationLogDrawer';
import PageHeader from '@components/PageHeader/PageHeader';
import LaborFeeFilterPanel from './LaborFeeFilterPanel';
const { Text } = Typography;

const filterFormItemLayout = {
    labelCol: {
        sm: { span: 20 },
        md: { span: 8 },
    },
    wrapperCol: {
        sm: { span: 24 },
        md: { span: 16 },
    },
};

const { setLaborFeeFilter: setFilter } = conferenceActions;

let expertId = null; // 劳务费上传凭证id
let expertName = null; //上传参会凭证选择专家名称

const initObj = {}; // 付款信息修改 - 比对"付款方式、劳务费支付主体"是否发生变动

const ConferenceLaborFeeRecords = () => {
    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const conferenceId = parseInt(params?.id, 10) || 0; // 会议项目 ID
    const [conference, setConference] = useState(null);

    const dispatch = useDispatch();
    const filter = useSelector(state => state.conference.laborFee.filter);
    const cursor = useSelector(state => state.conference.laborFee.cursor);
    // console.log(filter, cursor);

    const [filterForm] = Form.useForm();

    const [uploadForm] = Form.useForm();

    const [loading, setLoading] = useState(false);
    const [exportExpertLoading, setExportExpertLoading] = useState(false);
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);

    const [statisticalAmount, setStatisticalAmount] = useState(null);

    const [laborFeeForm] = Form.useForm();

    const [sendForm] = Form.useForm();

    const [editingKey, setEditingKey] = useState('');

    const [isModalOpen, setIsModalOpen] = useState(false);

    const [joinCertList, setJoinCertList] = useState([]);
    const [openCertificate, setOpenCertificate] = useState(false);
    const [chooseExpertIds, setChooseExpertIds] = useState([]);
    const [openChooseExpertModal, setOpenChooseExpertModal] = useState(false);
    const [batchNoList, setBatchNoList] = useState([]);

    const [openConfirmScheduleModal, setOpenConfirmScheduleModal] = useState(false);
    const [selectExpertId, setSelectExpertId] = useState(0);
    const [openConfirmBankInfoModal, setOpenConfirmBankInfoModal] = useState(false);
    const [openRecordDrawer, setOpenRecordDrawer] = useState(false);
    const [openPaymentBatchDrawer, setOpenPaymentBatchDrawer] = useState(false); // 付款申请批次 Drawer
    const [selectedBatchNo, setSelectedBatchNo] = useState(null); // 需要自动选中的批次号

    // 劳务需求备注弹窗
    const [demandRemarksModalVisible, setDemandRemarksModalVisible] = useState(false);
    const [demandRemarksForm] = Form.useForm();

    // 全屏状态
    const [isFullscreen, setIsFullscreen] = useState(false);
    const { filterToggleProps, FilterPanelSlot } = useFilterPanelVisible();

    // tableScrollY 三件套
    const tableRegionRef = useRef(null);
    const tableScrollContainerRef = useRef(null);
    const [scrollContainerVersion, setScrollContainerVersion] = useState(0);
    const tableDeductSelectors = useMemo(() => ['.main-toolbar'], []);
    const tableScrollY = useTableScrollY(tableRegionRef, {
        enabled: isFullscreen,
        heightRootClassName: 'main-container-card',
        scrollYOffset: 0,
        deductSiblingSelectors: tableDeductSelectors,
    });

    useHorizontalScrollGuard(tableScrollContainerRef, {
        threshold: 6,
        edgeHoldMs: 220,
        watchValue: scrollContainerVersion,
    });
    useVerticalScrollShadow(tableScrollContainerRef, {
        threshold: 2,
        watchValue: scrollContainerVersion,
    });

    useLayoutEffect(() => {
        const region = tableRegionRef.current;
        if (!region) return;

        const resolveScrollContainer = () => {
            const next = region.querySelector('.ant-table-body') ?? region.querySelector('.ant-table-content');
            if (tableScrollContainerRef.current !== next) {
                tableScrollContainerRef.current = next;
                setScrollContainerVersion(v => v + 1);
            }
        };

        resolveScrollContainer();

        let rafId = 0;
        const mutationObserver = new MutationObserver(() => {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                rafId = 0;
                resolveScrollContainer();
            });
        });
        mutationObserver.observe(region, { childList: true, subtree: true });

        return () => {
            if (rafId) cancelAnimationFrame(rafId);
            mutationObserver.disconnect();
        };
    }, []);

    const handleToggleFullscreen = useCallback(() => {
        const target = document.querySelector('main.main-container');
        if (!target) return;
        const next = !target.classList.contains('is-page-fullscreen');
        target.classList.toggle('is-page-fullscreen', next);
        setIsFullscreen(next);
    }, []);

    const handleRefresh = useCallback(async () => {
        setLoading(true);
        await Promise.all([getList(), getAmountStat()]);
        setLoading(false);
    }, [conferenceId]);

    useEffect(() => {
        const onKeyDown = e => {
            if (e.key !== 'Escape') return;
            const target = document.querySelector('main.main-container.is-page-fullscreen');
            if (!target) return;
            target.classList.remove('is-page-fullscreen');
            setIsFullscreen(false);
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, []);

    useEffect(() => {
        return () => {
            const target = document.querySelector('main.main-container.is-page-fullscreen');
            if (target) target.classList.remove('is-page-fullscreen');
        };
    }, []);

    const [previewImage, setPreviewImage] = useState(null);

    // 会议场次树数据（用于筛选"任务所属会议"）
    const [conferenceHallTreeData, setConferenceHallTreeData] = useState([]);

    const isEditing = record => record.expertId === editingKey;

    // 认证字典数据
    const [authDict, setAuthDict] = useState([]);

    // 请求认证字典数据
    const requestAuthDict = async () => {
        const res = await authdictionaryApi();
        if (!isEmpty(res?.options)) {
            const authDictData = res.options;
            authDictData
                && Array.isArray(authDictData)
                && authDictData.forEach(authType => {
                    authType.labels
                        && Array.isArray(authType.labels)
                        && authType.labels.forEach(label => {
                            label.options
                                && Array.isArray(label.options)
                                && label.options.forEach(l => {
                                    if (isEmpty(l.options)) {
                                        delete l.options;
                                    }
                                });
                        });
                });
            setAuthDict(authDictData);
        }
    };

    // 发送确认劳务信息任务
    const handleOk = () => {
        sendForm.validateFields().then(async values => {
            setIsModalOpen(false);
            Modal.confirm({
                title: '提示',
                width: 480,
                icon: <i className="bi bi-exclamation-circle" style={{ color: '#faad14' }} />,
                content: '发送任务后无法撤回，是否确认发送？',
                centered: true,
                okText: '确认',
                cancelText: '取消',
                onOk: async () => {
                    const res = await sendAgendaConfirmTaskApi({
                        ...values,
                        conferenceId,
                    });
                    if (res && res.status_code === 200) {
                        message.success('发送成功，您也可线下告知嘉宾回到[小程序-我的项目]中查看任务并处理');
                        sendForm.resetFields();
                        getList();
                        if (!!conferenceId) {
                            getConferenceInfo(conferenceId);
                        }

                        // 记录操作日志
                        // 医会议-劳务费管理-发送"确认劳务信息"任务
                        if (!!conferenceId) {
                            try {
                                await logSendLaborFeeConfirmationTask(conferenceId);
                            } catch (logError) {
                                console.error('操作日志上报失败', logError);
                                // 日志上报失败不影响主流程
                            }
                        }
                    }
                },
            });
        });
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    // 更新劳务费、付款信息
    const updateLaborFee = (record, type) => {
        laborFeeForm
            .validateFields()
            .then(async values => {
                if (values.paymentMethod === 3 && parseInt(values.laborFeeAmount, 10) !== 0) {
                    return message.warning('税后劳务费和付款方式不符，无法保存');
                }

                // 劳务费存在 - 则判断三个字段是否发生变动
                const equalLaborFeeAmount = parseInt(values.laborFeeAmount, 10) === parseInt(initObj?.laborFeeAmount, 10);
                if (values.laborFeeAmount && initObj?.paymentMethod === values.paymentMethod && initObj?.costBearer === values.costBearer && equalLaborFeeAmount) {
                    message.success('付款信息修改成功');
                    setEditingKey('');
                    return;
                }

                // 劳务费不存在 - 则判断两个字段是否发生变动
                if (!values.laborFeeAmount && initObj?.paymentMethod === values.paymentMethod && initObj?.costBearer === values.costBearer) {
                    message.success('付款信息修改成功');
                    setEditingKey('');
                    return;
                }

                const res = await updateLaborFeeApi({
                    projectCode: 'YHY',
                    projectId: conference?.id,
                    id: record.id || undefined,
                    expertId: record.expertId,
                    laborFeeAmount: values.laborFeeAmount || values.laborFeeAmount === 0 ? values.laborFeeAmount : record.laborFeeAmount,
                    paymentMethod: values.paymentMethod,
                    costBearer: values.costBearer,
                });
                if (res.status_code === 200) {
                    message.success(`${type === 1 ? '劳务费保存成功' : '付款信息修改成功'}`);
                    setEditingKey('');

                    getAmountStat();
                    getList();

                    if (!!conferenceId) {
                        getConferenceInfo(conferenceId);
                    }
                }
            })
            .catch(errorInfo => {
                console.log('errorInfo', errorInfo);

                const errors = [];
                errorInfo?.errorFields?.forEach(f => {
                    f.errors.forEach(e => {
                        errors.push(e);
                    });
                });

                if (errors.length) {
                    message.error(`${errors.join('；')}！`, 5);
                }
            });
    };

    const save = (record, type) => {
        if (type === 1) {
            updateLaborFee(record, type);
        } else {
            Modal.confirm({
                title: '提示',
                content: '确认修改付款信息',
                cancelText: '取消',
                okText: '确认',
                centered: true,
                closable: true,
                onOk: () => {
                    updateLaborFee(record, type);
                },
            });
        }
    };

    const getConferenceInfo = async conferenceId => {
        const res = await conferenceOnceApi({ id: conferenceId });
        if (res.status_code === 200) {
            setConference(res.data);
        }
    };

    // 劳务费批次列表
    const laborFeeRequestBatchesList = async () => {
        const res = await laborFeeRequestBatchesListApi({
            projectCode: 'YHY',
            projectId: conferenceId,
        });
        if (res.status_code === 200) {
            setBatchNoList(res.data);
        }
    };

    // 当 conferenceId 变化时，重置筛选条件到初始状态
    // 避免上一个项目的筛选条件影响新项目的数据查询
    useEffect(() => {
        if (!!conferenceId) {
            // 重置筛选条件，保留分页参数
            filterForm.resetFields();
            dispatch(
                setFilter({
                    page: 1,
                    pageSize: filter.pageSize || 10,
                }),
            );

            getConferenceInfo(conferenceId);
            laborFeeRequestBatchesList();
        }
        requestAuthDict();
    }, [conferenceId]);

    // 检查是否从待处理任务来，自动打开付款申请批次弹框并自动选中对应批次
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);

        if (searchParams.get('openPaymentBatch') === 'true' && conference) {
            setOpenPaymentBatchDrawer(true);
            // 获取 URL 中的 batchNo 参数
            const batchNo = searchParams.get('batchNo');
            if (batchNo) {
                setSelectedBatchNo(batchNo);
            }
        }
    }, [location.search, conference]);

    // 会议论坛列表 - 构建树
    const prepareConferenceHallTreeData = data => {
        const treeData = [];
        if (Object.keys(data)?.length) {
            Object.keys(data).forEach(agendaDate => {
                const dateNode = {
                    title: agendaDate,
                    value: agendaDate,
                    selectable: false,
                    hallNum: 0,
                    children: [],
                };
                const confHalls = data[agendaDate];
                confHalls?.length
                    && confHalls.forEach(confHall => {
                        const hallNode = {
                            title: `${confHall.name} [YHYC#${confHall.id}]`,
                            value: confHall.id,
                            children: [],
                        };
                        const confSubHalls = confHall.secondHallsList || [];
                        if (confSubHalls?.length) {
                            hallNode.selectable = false;
                            confSubHalls.forEach(subHall => {
                                dateNode.hallNum += 1;
                                hallNode.children.push({
                                    title: `${subHall.name} [YHYC#${subHall.id}]`,
                                    value: subHall.id,
                                });
                            });
                        } else {
                            dateNode.hallNum += 1;
                        }
                        dateNode.children.push(hallNode);
                    });
                treeData.push(dateNode);
            });
        }
        return treeData;
    };

    // 获取会议列表（用于"任务所属会议"筛选项）
    const getConferenceList = useCallback(async () => {
        const res = await getConferenceListApi({ conferenceId });
        if (res?.status_code === 200 && res?.data) {
            const agendaData = res.data;
            setConferenceHallTreeData(prepareConferenceHallTreeData(agendaData));
        }
    }, [conferenceId]);

    useEffect(() => {
        if (!!conferenceId) {
            getConferenceList();
        }
    }, [getConferenceList, conferenceId]);

    const onFormFinish = values => {
        // 过滤掉 undefined 和 null 值，只保留有效的筛选条件
        const newValues = {};
        Object.keys(values).forEach(key => {
            const val = values[key];
            // 保留非空值（包括 0 和 false）
            if (val !== undefined && val !== null && val !== '') {
                // 兼容接口未处理空数组的情况
                if (Array.isArray(val) && val.length === 0) {
                    return;
                }
                newValues[key] = val;
            }
        });

        dispatch(
            setFilter({
                page: 1,
                pageSize: filter.pageSize,
                ...newValues,
            }),
        );
    };

    const onReset = () => {
        filterForm.resetFields();

        // 重置时只保留分页参数，彻底清除所有筛选条件
        dispatch(
            setFilter({
                page: 1,
                pageSize: filter.pageSize,
            }),
        );

        // 重置筛选时清空已选择的专家，避免重新加载数据时触发二次确认弹框
        setChooseExpertIds([]);
    };

    const onChangePage = (page, pageSize) => {
        dispatch(
            setFilter({
                ...filter,
                page,
                pageSize,
            }),
        );
    };

    const onShowSizeChange = pageSize => onChangePage(1, pageSize);

    // 获取当前登录用户的手机号
    const getCurrentUserPhone = () => {
        const adminInfo = localStorage.getItem('infos');
        let userPhone = null;
        if (adminInfo && JSON.parse(adminInfo)) {
            const info = JSON.parse(adminInfo)?.data;
            userPhone = JSON.parse(info)?.phone;
        }
        return userPhone;
    };

    // 劳务费列表
    const getList = async () => {
        setLoading(false);
        const newValues = { ...filter };
        const res = await laborFeeListApi({
            ...newValues,
            projectCode: 'YHY',
            projectId: conferenceId,
            laborFeeDemand: 1,
        });
        if (res.status_code === 200) {
            setData(res?.data?.list || []);
            setTotal(res?.data?.totalCount || 0);
        }
        setLoading(false);
    };

    // 劳务费和个税统计金额
    const getAmountStat = async () => {
        const res = await statisticalAmountApi({ projectCode: 'YHY', projectId: conferenceId });
        if (res.status_code === 200) {
            const amountStat = res?.data || null;
            setStatisticalAmount(amountStat);
        }
    };

    // 发送确认实际日程任务
    const sendAgendaTask = () => {
        setIsModalOpen(true);
    };

    const comfirmScheduleAction = expertId => {
        setSelectExpertId(expertId);
        setOpenConfirmScheduleModal(true);
    };
    const confirmBankInfoAction = expertId => {
        setSelectExpertId(expertId);
        setOpenConfirmBankInfoModal(true);
    };

    useEffect(() => {
        // 从 filter 中提取表单相关的字段，排除分页参数
        const formFields = { ...filter };
        delete formFields.page;
        delete formFields.pageSize;

        // 先重置表单，再设置有效值，避免残留旧值
        filterForm.resetFields();
        // 只设置有值的字段到表单
        const validFields = {};
        Object.keys(formFields).forEach(key => {
            const val = formFields[key];
            if (val !== undefined && val !== null && val !== '') {
                validFields[key] = val;
            }
        });
        if (Object.keys(validFields).length > 0) {
            filterForm.setFieldsValue(validFields);
        }

        getList();
    }, [filter]);

    useEffect(() => {
        getAmountStat();
    }, []);

    // 检查专家付款申请状态
    const checkExpertPaymentStatus = expert => {
        const payRecords = expert.laborFeePayRecordDtoList || [];

        // 检查是否有待付款的记录（不是待提交状态，且未付款）
        const hasPendingPayment = payRecords.some(
            payRecord =>
                !(payRecord.approvalStatus === 1 || !payRecord.approvalStatus) // 不是待提交状态
                && !payRecord.payedAt, // 未付款
        );

        return hasPendingPayment;
    };

    // 监听 chooseExpertIds 变化，判断是否存在已有付款申请批次的专家
    useEffect(() => {
        if (!chooseExpertIds || chooseExpertIds.length === 0) {
            return;
        }

        // 获取当前勾选的行数据
        const selectedRows = data.filter(row => chooseExpertIds.includes(row.expertId));

        // 筛选出已有付款申请记录的专家（根据 laborFeePayRecordDtoList 判断）
        const expertsWithPaymentRequest = selectedRows.filter(row => row.laborFeePayRecordDtoList && row.laborFeePayRecordDtoList.length > 0);

        // 如果没有已有付款申请记录的专家，直接返回
        if (expertsWithPaymentRequest.length === 0) {
            return;
        }

        // 单选场景
        if (chooseExpertIds.length === 1 && expertsWithPaymentRequest.length === 1) {
            const expert = selectedRows[0];
            const hasPendingPayment = checkExpertPaymentStatus(expert);

            let content;
            if (hasPendingPayment) {
                // 有待付款记录
                content = (
                    <>
                        <div>
                            <Text type="danger">所选专家：{expert.memUsername}，在本项目中存在付款申请记录，且付款流程正在进行中。</Text>
                        </div>
                        <div style={{ marginTop: 8 }}>
                            <Text strong>请确认所选专家是否需要多次付款，以避免重复申请。</Text>
                        </div>
                        <div style={{ marginTop: 8 }}>若无需多次付款，请点击【取消】。</div>
                        <div>若确认需要再次付款，请点击【确认】。</div>
                    </>
                );
            } else {
                // 所有记录都是已付款
                content = (
                    <>
                        <div>
                            <Text type="danger">所选专家：{expert.memUsername}，在本项目中存在付款申请记录。</Text>
                        </div>
                        <div style={{ marginTop: 8 }}>
                            <Text strong>请确认所选专家是否需要多次付款，以避免重复申请。</Text>
                        </div>
                        <div style={{ marginTop: 8 }}>若无需多次付款，请点击【取消】。</div>
                        <div>若确认需要再次付款，请点击【确认】。</div>
                    </>
                );
            }

            Modal.confirm({
                title: '提示',
                width: 480,
                content: content,
                centered: true,
                okText: '确认',
                cancelText: '取消',
                icon: <i className="bi bi-exclamation-circle"></i>,
                onOk: () => {
                    // 用户确认后继续
                },
                onCancel: () => {
                    // 用户取消，需要取消勾选
                    setChooseExpertIds(chooseExpertIds.filter(key => key !== expert.expertId));
                },
            });
        } else if (chooseExpertIds.length > 1 && expertsWithPaymentRequest.length > 0) {
            // 多选场景，且存在已有付款申请记录的专家

            // 检查这些专家中是否有任何待付款的记录
            const hasAnyPendingPayment = expertsWithPaymentRequest.some(expert => {
                const hasPendingPayment = checkExpertPaymentStatus(expert);
                return hasPendingPayment;
            });

            const expertNames = expertsWithPaymentRequest.map(e => e.memUsername).join('、');

            let content;
            if (hasAnyPendingPayment) {
                // 存在待付款记录
                content = (
                    <>
                        <div>
                            <Text type="danger">以下专家，在本项目中存在付款申请记录，且有专家付款流程正在进行中。</Text>
                        </div>
                        <div style={{ marginTop: 8 }}>
                            <Text type="danger">{expertNames}</Text>
                        </div>
                        <div style={{ marginTop: 8 }}>
                            <Text strong>请确认所选专家是否需要多次付款，以避免重复申请。</Text>
                        </div>
                        <div style={{ marginTop: 8 }}>若无需多次付款，请点击【取消】。</div>
                        <div>若确认需要再次付款，请点击【确认】。</div>
                    </>
                );
            } else {
                // 所有专家的所有记录都是已付款
                content = (
                    <>
                        <div>
                            <Text type="danger">以下专家，在本项目中存在付款申请记录。</Text>
                        </div>
                        <div style={{ marginTop: 8 }}>
                            <Text type="danger">{expertNames}</Text>
                        </div>
                        <div style={{ marginTop: 8 }}>
                            <Text strong>请确认所选专家是否需要多次付款，以避免重复申请。</Text>
                        </div>
                        <div style={{ marginTop: 8 }}>若无需多次付款，请点击【取消】。</div>
                        <div>若确认需要再次付款，请点击【确认】。</div>
                    </>
                );
            }

            Modal.confirm({
                title: '提示',
                width: 480,
                content: content,
                centered: true,
                okText: '确认',
                cancelText: '取消',
                icon: <i className="bi bi-exclamation-circle"></i>,
                onOk: () => {
                    // 用户确认后继续
                },
                onCancel: () => {
                    // 用户取消，需要取消勾选
                    const filteredKeys = chooseExpertIds.filter(key => !expertsWithPaymentRequest.some(expert => expert.expertId === key));
                    setChooseExpertIds(filteredKeys);
                },
            });
        }
    }, [chooseExpertIds, data]);

    // 格式化货币
    const formatCurrency = value => {
        const f = parseFloat(value) || 0.0;
        const parts = f.toFixed(2).split('.');
        const result = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') + (parts[1] ? `.${parts[1]}` : '');
        return result;
    };

    // 获取专家证件类型
    const getIdCardType = cardType => {
        const type = parseInt(cardType, 10);
        const target = cardTypes.find(item => item.code === type);
        return target?.name || null;
    };

    const toggleAgendaTasks = guestAgendaInfo => {
        setData(
            data.map(item => {
                if (item.expertId === guestAgendaInfo.expertId) {
                    return { ...item, expanded: !item.expanded };
                } else {
                    return item;
                }
            }),
        );
    };

    const finishPendingTaskNavigation = useCallback(() => {
        const urlParams = new URLSearchParams(location.search);
        const fromPage = urlParams.get('fromPage');

        if (fromPage && fromPage !== location.pathname) {
            navigate(fromPage, { replace: true });
            return;
        }

        navigate({ pathname: location.pathname, search: '' }, { replace: true });
    }, [location.pathname, location.search, navigate]);

    const onCloseBatchDrawer = () => {
        setOpenPaymentBatchDrawer(false);
        getList();
        getAmountStat();
        finishPendingTaskNavigation();
    };

    // 从外部页面（如首页）进入时，审批完成后同步关闭付款申请批次抽屉并返回来源页
    const onApprovalFlowComplete = useCallback(() => {
        const urlParams = new URLSearchParams(location.search);
        const fromPage = urlParams.get('fromPage');

        if (!fromPage || fromPage === location.pathname) {
            return;
        }

        setOpenPaymentBatchDrawer(false);
        getList();
        getAmountStat();
        navigate(fromPage, { replace: true });
    }, [location.pathname, location.search, navigate]);

    // 检查专家是否满足勾选条件
    const canSelectExpert = record => {
        // 条件1：专家实际日程未确认
        if (!record.agendaConfirmed) {
            return false;
        }

        // 条件2：专家收款信息不完整或未确认
        if (!record.laborInfoConfirmed || record.expertInfoState === 0) {
            // 0表示不完整
            return false;
        }

        // 条件3：无手机号专家
        if (!record.memMobile || record.memMobile.trim() === '') {
            return false;
        }

        // 条件4：无签到记录
        if (!record.signTime) {
            return false;
        }

        // 条件5：未上传参会凭证
        if (!record.joinCert?.trim()) {
            return false;
        }

        // 条件6：有付款申请记录为待提交状态时
        if (record.laborFeePayRecordDtoList && record.laborFeePayRecordDtoList.length > 0) {
            const hasPendingSubmission = record.laborFeePayRecordDtoList.some(
                payRecord => payRecord.approvalStatus === 1 || !payRecord.approvalStatus, // 待提交状态
            );
            if (hasPendingSubmission) {
                return false;
            }
        }

        return true;
    };

    // 处理行勾选 - 仅更新状态
    const handleSelectionChange = selectedRowKeys => {
        setChooseExpertIds(selectedRowKeys);
    };

    const defaultColumns = [
        {
            title: '基本信息',
            width: 200,
            dataIndex: 'memUsername',
            fixed: 'left',
            render: (_, record) => <ExpertInfoCard expert={record} />,
        },
        {
            title: '单位及职务',
            dataIndex: 'unitPost',
            width: 180,
            // align: 'center',
            render: (_, row) => {
                if (row.workExpList?.length) {
                    return (
                        <>
                            {row.workExpList.map((item, index) => {
                                const officePostDisplay = formatOfficeAndPost(item, dictMaps);
                                const unitName = item.unitName || '';
                                const fullDisplay = [unitName, officePostDisplay].filter(Boolean).join('');
                                const displayIndex = index + 1;

                                return (
                                    <span key={`w_${item.id}`}>
                                        {row.workExpList.length > 1 && `${displayIndex}. `}
                                        {fullDisplay || ''}
                                    </span>
                                );
                            })}
                        </>
                    );
                } else {
                    return '—';
                }
            },
        },
        {
            title: '实际任务',
            dataIndex: 'agendasList',
            width: 400,
            render: (_, record) => {
                // 将 agendasList 映射为 agendasGuestsList 结构
                const agendasGuestsList = record.agendasList || [];

                return (
                    <>
                        <GuestTaskList agendasGuestsList={agendasGuestsList} expanded={record.expanded} onToggleExpansion={toggleAgendaTasks} record={record} />
                        <div>
                            {record.agendaConfirmed ? (
                                <Text type="success">已确认</Text>
                            ) : (
                                <span style={{ display: 'flex', alignItems: 'center' }}>
                                    <Text type="secondary">未反馈</Text>
                                    <Button
                                        type="link"
                                        size="small"
                                        style={{ paddingLeft: 8, paddingRight: 0, display: 'flex', alignItems: 'center' }}
                                        icon={
                                            <span className="anticon">
                                                <i className="bi bi-pencil"></i>
                                            </span>
                                        }
                                        onClick={() => comfirmScheduleAction(record.expertId)}
                                    >
                                        代确认
                                    </Button>
                                </span>
                            )}
                        </div>
                    </>
                );
            },
        },
        {
            title: '付款申请记录',
            dataIndex: 'laborFeePayRecordDtoList',
            width: 300,
            render: (_, record) => {
                const payRecords = record.laborFeePayRecordDtoList || [];
                if (!payRecords || payRecords.length === 0) {
                    return <Text type="secondary">暂无</Text>;
                }

                // 按卡片格式展示所有付款记录
                return (
                    <div className="pay-record-card-list">
                        {payRecords.map((payRecord, index) => {
                            const costBearerLabel = laborFeeCostBearers.find(b => b.value === payRecord.costBearer)?.label || <Text type="secondary">暂无</Text>;

                            // 判断是否为外币
                            const isForeignCurrency = payRecord.currency && payRecord.currency !== 'CNY';
                            const currencyType = CurrencyList.find(c => c.currency === payRecord.currency)?.name || payRecord.currency;

                            return (
                                <div
                                    key={payRecord.batchNo}
                                    className="pay-record-card"
                                    onClick={() => {
                                        // 打开付款申请批次弹框并选中对应批次
                                        setSelectedBatchNo(payRecord.batchNo);
                                        setOpenPaymentBatchDrawer(true);
                                    }}
                                >
                                    <div className="pay-record-card__body">
                                        <div>
                                            申请批次：{convertDateTimeToLocalText(payRecord.createdAt)}
                                            {payRecord.createdName && `(${payRecord.createdName})`}
                                        </div>
                                        <div>支付主体：{costBearerLabel}</div>
                                        {isForeignCurrency ? (
                                            // 外币展示格式
                                            <>
                                                <div>
                                                    外币实发额({currencyType})：{payRecord.foreignExchangeAmount !== null ? formatCurrency(payRecord.foreignExchangeAmount) : <Text type="secondary">暂无</Text>}(
                                                    {payRecord.approvalStatus === 1 || !payRecord.approvalStatus ? <Text type="warning">待提交</Text> : payRecord.payedAt ? <Text type="success">已付款</Text> : <Text type="warning">待付款</Text>})
                                                </div>
                                                <div>折合人民币实发劳务费(元)：{payRecord.laborFeeAmount !== null ? `${formatCurrency(payRecord.laborFeeAmount)}` : <Text type="secondary">暂无</Text>}</div>
                                            </>
                                        ) : (
                                            // 人民币展示格式
                                            <div>
                                                实发劳务费(元)：{payRecord.laborFeeAmount !== null ? `${formatCurrency(payRecord.laborFeeAmount)}` : <Text type="secondary">暂无</Text>}(
                                                {payRecord.approvalStatus === 1 || !payRecord.approvalStatus ? <Text type="warning">待提交</Text> : payRecord.payedAt ? <Text type="success">已付款</Text> : <Text type="warning">待付款</Text>})
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                );
            },
        },
        {
            title: '收款信息',
            dataIndex: 'bankName',
            width: 250,
            render: (_, record) => (
                <>
                    {(record.idcardType === 1 || !record.idcardType) && (
                        <>
                            <span>身份证号码：{record.idCard || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>出生日期：{(!!record.birthday && dayjs(record.birthday).format('YYYY年M月D日')) || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>性别：{(record.memGender !== null && (Number(record.memGender) === 1 ? '男' : '女')) || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>银行账号：{record.bankCardNo || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>开户银行：{record.bankName || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <div>
                                {record.laborInfoConfirmed ? (
                                    <Text type="success">已确认</Text>
                                ) : (
                                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <Text type="secondary">未反馈</Text>
                                        <Button
                                            type="link"
                                            size="small"
                                            style={{ paddingLeft: 8, paddingRight: 0, display: 'flex', alignItems: 'center' }}
                                            icon={
                                                <span className="anticon">
                                                    <i className="bi bi-pencil"></i>
                                                </span>
                                            }
                                            onClick={() => confirmBankInfoAction(record.expertId)}
                                        >
                                            代确认
                                        </Button>
                                    </span>
                                )}
                            </div>
                        </>
                    )}
                    {record.idcardType > 1 && record.bankType !== 2 && (
                        <>
                            <span>证件类型：{getIdCardType(record.idcardType) || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>证件号：{record.idCard || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>国籍：{record.nationality || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>出生日期：{(!!record.birthday && dayjs(record.birthday).format('YYYY年M月D日')) || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>出生地：{record.birthPlace || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>性别：{(record.memGender !== null && (Number(record.memGender) === 1 ? '男' : '女')) || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>银行账号：{record.bankCardNo || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>开户银行：{record.bankName || <Text type="secondary">&ndash;</Text>}</span>
                            <div>
                                {record.laborInfoConfirmed ? (
                                    <Text type="success">已确认</Text>
                                ) : (
                                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <Text type="secondary">未反馈</Text>
                                        <Button
                                            type="link"
                                            size="small"
                                            style={{ paddingLeft: 8, paddingRight: 0, display: 'flex', alignItems: 'center' }}
                                            icon={
                                                <span className="anticon">
                                                    <i className="bi bi-pencil"></i>
                                                </span>
                                            }
                                            onClick={() => confirmBankInfoAction(record.expertId)}
                                        >
                                            代确认
                                        </Button>
                                    </span>
                                )}
                            </div>
                        </>
                    )}
                    {record.idcardType > 1 && record.bankType === 2 && (
                        <>
                            <span>证件类型：{getIdCardType(record.idcardType) || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>证件号：{record.idCard || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>国籍：{record.nationality || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>出生日期：{(!!record.birthday && dayjs(record.birthday).format('YYYY年M月D日')) || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>出生地：{record.birthPlace || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>性别：{(record.memGender !== null && (Number(record.memGender) === 1 ? '男' : '女')) || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>收款人姓名(英文)：{record.payeeUsername || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>收款人银行预留电话：{record.payeePhone || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>收款人境外汇款住址(英文)：{record.payeeAddress || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>开户行名称(英文)：{record.bankName || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>银行账号：{record.bankCardNo || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <span>SWIFT/BIC Code：{record.swiftBicCode || <Text type="secondary">&ndash;</Text>}</span>
                            <br />
                            <div>
                                {record.laborInfoConfirmed ? (
                                    <Text type="success">已确认</Text>
                                ) : (
                                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <Text type="secondary">未反馈</Text>
                                        <Button
                                            type="link"
                                            size="small"
                                            style={{ paddingLeft: 8, paddingRight: 0, display: 'flex', alignItems: 'center' }}
                                            icon={
                                                <span className="anticon">
                                                    <i className="bi bi-pencil"></i>
                                                </span>
                                            }
                                            onClick={() => confirmBankInfoAction(record.expertId)}
                                        >
                                            代确认
                                        </Button>
                                    </span>
                                )}
                            </div>
                        </>
                    )}
                </>
            ),
        },
        {
            title: '参会信息',
            dataIndex: 'signTime',
            width: 200,
            render: (_, record) => (
                <>
                    <div>签到时间：{record.signTime ? convertDateTimeToLocalText(record.signTime) : <Text type="secondary">暂无</Text>}</div>
                    <div>
                        签到方式：
                        {record.checkType === 1 && '线下核销签到'}
                        {record.checkType === 2 && '线上自助签到'}
                        {record.checkType === 3 && <Text type="danger">后台代签</Text>}
                        {!record.checkType && <Text type="secondary">暂无</Text>}
                    </div>
                    <div>
                        参会凭证：
                        {record.joinCert ? (
                            <Button type="link" size="small" style={{ paddingLeft: 0, paddingRight: 0 }} onClick={() => setPreviewImage(record.joinCert)}>
                                查看
                            </Button>
                        ) : (
                            <Text type="secondary">暂无</Text>
                        )}
                    </div>
                    <div>
                        <Button
                            type="link"
                            size="small"
                            style={{ paddingLeft: 0, paddingRight: 0, display: 'flex', alignItems: 'center' }}
                            icon={
                                <span className="anticon">
                                    <i className="bi bi-pencil"></i>
                                </span>
                            }
                            onClick={() => uploadConferenceCert(record)}
                        >
                            {record.joinCert ? '修改参会凭证' : '上传参会凭证'}
                        </Button>
                    </div>
                </>
            ),
        },
    ];

    const columns = defaultColumns.map(col => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: record => ({
                record,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });

    // 表格 rowSelection 配置
    const rowSelection = {
        selectedRowKeys: chooseExpertIds,
        onChange: (selectedRowKeys, selectedRows) => {
            handleSelectionChange(selectedRowKeys, selectedRows);
        },
        // 禁用不符合条件的行的勾选
        getCheckboxProps: record => ({
            disabled: !canSelectExpert(record),
        }),
    };

    // 获取含税金额
    const getTotalAmount = (LaborFeeSum, IndividualTaxSum) => {
        if (LaborFeeSum !== null && IndividualTaxSum !== null) {
            return (Number(LaborFeeSum) + Number(IndividualTaxSum)).toFixed(2);
        }
    };

    const checkImgUploadFile = (file, sizeMb) => {
        const typeList = ['image/jpg', 'image/jpeg', 'image/png'];
        const isImage = typeList.includes(file.type) || false;

        if (!isImage) {
            message.error('仅支持 JPG/PNG 图片格式');
            return false;
        }

        const metSize = file.size / 1024 / 1024 < sizeMb;
        if (!metSize) {
            message.error(`图片文件大小限${sizeMb}MB`);
            return false;
        }

        return isImage && metSize;
    };

    const uploadImageFile = (fileInfo, type) => {
        const formData = new FormData();
        formData.append('file', fileInfo.file);
        formData.append('type', 14);

        fileApi(formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(async res => {
            if (!res) {
                message.error('文件上传失败');
                return false;
            }

            if (res.status_code === 200) {
                const url = prepareBCOSSUrl(res.data);
                if (type === 'joinCert') {
                    setJoinCertList([url]);
                    uploadForm.setFieldValue('joinCert', res.data);
                }
            }
        });
    };

    // 上传/修改参会凭证
    const uploadConferenceCert = record => {
        expertId = record.expertId;
        expertName = record.memUsername;
        if (record.joinCert) {
            setJoinCertList([prepareBCOSSUrl(record.joinCert)]);
        }
        setOpenCertificate(true);
    };

    const handleCancelCertificate = () => {
        setOpenCertificate(false);
        setJoinCertList([]);
        expertId = null;
        uploadForm.resetFields();
    };

    // 删除参会凭证
    const deleteImg = () => {
        setJoinCertList([]);
        uploadForm.setFieldValue('joinCert', '');
    };

    // 保存参会凭证
    const handleAddCertificate = () => {
        uploadForm.validateFields().then(async values => {
            const res = await savelaborFeeJoinCertApi({
                projectId: conferenceId,
                expertId,
                joinCert: values.joinCert,
            });
            if (res.status_code === 200) {
                message.success('保存成功');
                setOpenCertificate(false);
                getList();

                setJoinCertList([]);
                expertId = null;
                uploadForm.resetFields();
            }
        });
    };

    // 是否拥有劳务费录入人员权限
    const canConfirmLaborFeeEntry = useMemo(() => {
        const roleList = localStorageGet('roleList') ? JSON.parse(localStorageGet('roleList')) : [];
        if (roleList?.length) {
            return roleList.some(item => item.name === '劳务费录入人员');
        }
        return false;
    }, []);

    // 是否拥有导出专家劳务费信息权限
    const canExportExpertLaborFee = useMemo(() => {
        const roleList = localStorageGet('roleList') ? JSON.parse(localStorageGet('roleList')) : [];
        if (roleList && roleList.length) {
            return roleList.some(item => item.name === '导出专家劳务费信息');
        }
        return false;
    }, []);

    const sanitizeExportFileNamePart = value => String(value ?? '').replace(/[/\\?*:|"<>]/g, '_');

    const exportExpertLaborFee = async () => {
        if (exportExpertLoading || !conferenceId) {
            return;
        }
        try {
            setExportExpertLoading(true);
            message.success('请稍后，正在导出');
            const { page, pageSize, ...rest } = filter;
            const blob = await exportExpertLaborFeeDownloadV2Api({
                ...rest,
                projectCode: 'YHY',
                projectId: conferenceId,
                laborFeeDemand: 1,
            });
            if (!blob || !(blob instanceof Blob) || blob.size === 0) {
                message.warning('当前筛选无数据，无法导出');
                return;
            }
            const projectName = sanitizeExportFileNamePart(conference?.name || '会议');
            const fileName = `劳务费专家_${conferenceId}_${projectName}_${dayjs().format('YYYYMMDDHHmmss')}.xlsx`;
            const objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = fileName;
            link.click();
            URL.revokeObjectURL(objectUrl);
        } catch (error) {
            console.error('导出专家劳务费信息失败', error);
        } finally {
            setExportExpertLoading(false);
        }
    };

    // 设置劳务需求备注
    const setLaborFeeDemandRemarks = () => {
        // 打开弹窗，如果有现有备注则填充（从会议详情中获取）
        demandRemarksForm.setFieldsValue({
            remarks: conference?.laborFeeDemandRemarks || '',
        });
        setDemandRemarksModalVisible(true);
    };

    // 提交劳务需求备注
    const handleSubmitDemandRemarks = async () => {
        try {
            const values = await demandRemarksForm.validateFields();
            const res = await setLaborFeeDemandRemarkApi({
                conferenceId,
                remarks: values.remarks || '',
            });
            if (res.status_code === 200) {
                message.success('设置成功');
                setDemandRemarksModalVisible(false);
                // 重新获取会议详情以更新备注显示
                await getConferenceInfo(conferenceId);
            } else {
                message.error(res.message || '设置失败');
            }
        } catch (error) {
            console.error('设置劳务需求备注失败：', error);
            if (error.errorFields) {
                // 表单验证错误，不显示错误消息
                return;
            }
            message.error('设置失败');
        }
    };

    // 取消设置劳务需求备注
    const handleCancelDemandRemarks = () => {
        setDemandRemarksModalVisible(false);
        demandRemarksForm.resetFields();
    };

    // 创建付款申请批次
    const handleCreatePaymentBatch = async () => {
        // 检查是否有勾选的专家
        if (!chooseExpertIds || chooseExpertIds.length === 0) {
            message.warning('请勾选专家');
            return;
        }

        try {
            // 调用接口创建付款申请批次
            const res = await laborFeeBatchApplyApi({
                h3yunNo: conference?.h3yunNo || 'YHY',
                projectId: conferenceId,
                expertIds: chooseExpertIds,
            });

            if (res && res.status_code === 200 && res.data) {
                message.success('创建批次成功');
                // 清空勾选
                setChooseExpertIds([]);
                // 打开付款申请批次弹窗
                setOpenPaymentBatchDrawer(true);
                // 设置最新批次号
                setSelectedBatchNo(res.data.batchNo);
                // 刷新批次列表
                laborFeeRequestBatchesList();
            } else {
                message.error(res?.message || '创建批次失败');
            }
        } catch (error) {
            console.error('创建付款申请批次失败:', error);
            message.error('创建批次失败');
        }
    };

    // 根据认证字典构建映射
    const dictMaps = useMemo(() => buildAuthDictMaps(authDict), [authDict]);

    useEffect(() => {
        document.title = '劳务费管理-医会议';
    }, []);

    useEffect(() => {
        if (!conferenceId || !conference || !conference.name) {
            return;
        }

        // 后台管理员信息
        const { adminId, adminName, adminPhone } = getAdminInfo();

        // QT 埋点
        // 页面浏览：医会议-劳务费管理页面
        if (window.aplus_queue?.push) {
            window.aplus_queue.push({
                action: 'aplus.sendPV',
                arguments: [
                    { is_auto: false },
                    {
                        page_name: 'view_conf_laborfee_page', // 页面名称
                        admin_id: adminId || '', // 后台管理员ID
                        admin_name: adminName || '', // 后台管理员姓名
                        admin_phone: adminPhone || '', // 后台管理员手机号
                        project_type: 'conference', // 项目类型
                        project_id: conferenceId || '', // 项目ID
                        project_title: conference?.name || '', // 项目名称
                    },
                ],
            });
        } else {
            console.error('aplus_queue 对象未定义');
        }
    }, [conferenceId, conference]);

    return (
        <div className="page-container list-page-container labor-fee-manage">
            <PageHeader title="专家劳务" breadcrumb={[{ label: '医会议', path: CONFERENCE_WORKSPACE_PARENT_PATH }, { label: conference?.name || '项目信息', path: `${CONFERENCE_WORKSPACE_ROUTE_BASE}/${conferenceId}` }, '专家劳务']} {...filterToggleProps} />

            <FilterPanelSlot>
                <LaborFeeFilterPanel filter={filter} conferenceHallTreeData={conferenceHallTreeData} batchNoList={batchNoList} onFinish={onFormFinish} onReset={onReset} />
            </FilterPanelSlot>

            {conference?.labelPayment === 1 && (
                <Alert
                    type="info"
                    className="labor-fee-summary-alert"
                    style={{ marginBottom: 10, fontSize: 12 }}
                    title={
                        <>
                            <Row>
                                <Col className="summary-ammount" span={24}>
                                    <b>项目信息：</b>
                                    <span style={{ fontSize: 12 }}>
                                        {conference?.name}，氚云项目编号：{conference?.h3yunNo}，会议项目编号：{numberProject('YHY', conference?.id)}
                                    </span>
                                </Col>
                            </Row>
                            {!statisticalAmount?.demandRemarks && (
                                <Row>
                                    <Col className="summary-ammount" span={24}>
                                        <b>本项目累计付款申请：</b>
                                        <span style={{ fontSize: 12 }}>
                                            专家总数：{statisticalAmount?.expertSum}人，需要劳务费人数：{statisticalAmount?.realTotal}人，付款申请人数：{statisticalAmount?.expertAppliedSum}人，已付款人数：{statisticalAmount?.expertPaySum}人，实发劳务费合计金额（元）：
                                            {formatCurrency(statisticalAmount?.LaborFeeSum)}，个人所得税合计金额（元）：{formatCurrency(statisticalAmount?.IndividualTaxSum)}，含税劳务费合计金额（元）：{formatCurrency(getTotalAmount(statisticalAmount?.LaborFeeSum, statisticalAmount?.IndividualTaxSum))}
                                        </span>
                                    </Col>
                                </Row>
                            )}
                            <Row>
                                <Col className="demand-remarks" span={24}>
                                    <b>劳务需求备注：</b>
                                    {conference?.laborFeeDemandRemarks ? (
                                        <>
                                            <span>{conference.laborFeeDemandRemarks}</span>
                                            <Button
                                                type="link"
                                                size="small"
                                                onClick={setLaborFeeDemandRemarks}
                                                style={{ paddingLeft: 8 }}
                                                icon={
                                                    <span className="anticon">
                                                        <i className="bi bi-pencil"></i>
                                                    </span>
                                                }
                                            />
                                        </>
                                    ) : (
                                        <>
                                            未填写{' '}
                                            <Button
                                                type="link"
                                                size="small"
                                                onClick={setLaborFeeDemandRemarks}
                                                icon={
                                                    <span className="anticon">
                                                        <i className="bi bi-pencil"></i>
                                                    </span>
                                                }
                                            />
                                        </>
                                    )}
                                </Col>
                            </Row>
                        </>
                    }
                />
            )}

            <Alert
                type="warning"
                className="labor-fee-disabled-alert"
                style={{ marginBottom: 16, fontSize: 12 }}
                title={
                    <div>
                        <div>未找到专家原因：请在“会议嘉宾”模块中，为专家标记劳务需求（只有标记为“需要”的专家，才可在本模块申请劳务）</div>
                        <div>专家不可勾选原因：1. 实际日程未确认；2. 收款信息不完整或未确认；3. 无手机号；4. 无签到记录；5. 未上传参会凭证；6. 有付款申请记录为待提交状态时</div>
                    </div>
                }
            />

            <div ref={tableRegionRef} className="table-region-container labor-fee-table-region">
                <div className="main-toolbar">
                    <div className="main-tools">
                        <Space>
                            {canConfirmLaborFeeEntry && (
                                <Button type="primary" disabled={!!conference?.agendaConfirmContactsName} onClick={sendAgendaTask}>
                                    {!!conference?.agendaConfirmContactsName && '已'}发送【确认劳务信息】任务
                                </Button>
                            )}
                        </Space>
                    </div>
                    <div className="sub-tools">
                        <Space>
                            <Button onClick={handleCreatePaymentBatch}>创建付款申请</Button>

                            {batchNoList && batchNoList.length > 0 && <Button onClick={() => setOpenPaymentBatchDrawer(true)}>已创建付款申请</Button>}

                            {canExportExpertLaborFee && (
                                <Tooltip title="导出专家劳务费信息（三方前置审批用）">
                                    <Button
                                        loading={exportExpertLoading}
                                        icon={
                                            <span className="anticon">
                                                <i className="bi bi-cloud-download"></i>
                                            </span>
                                        }
                                        onClick={exportExpertLaborFee}
                                    />
                                </Tooltip>
                            )}

                            <Tooltip title="刷新">
                                <Button
                                    type="default"
                                    icon={
                                        <span className="anticon">
                                            <i className="bi bi-arrow-clockwise"></i>
                                        </span>
                                    }
                                    onClick={handleRefresh}
                                />
                            </Tooltip>

                            <Tooltip title={isFullscreen ? '退出全屏' : '全屏'}>
                                <Button
                                    type="default"
                                    icon={
                                        <span className="anticon">
                                            <i className={`bi ${isFullscreen ? 'bi-fullscreen-exit' : 'bi-fullscreen'}`}></i>
                                        </span>
                                    }
                                    onClick={handleToggleFullscreen}
                                />
                            </Tooltip>
                        </Space>
                    </div>
                </div>

                <div className="list-table-wrap labor-fee-table-wrap">
                    <Form form={laborFeeForm} component={false}>
                        <Table
                            className={tableScrollY != null ? 'custom-table-scrollbar-always' : undefined}
                            columns={columns}
                            dataSource={data}
                            loading={loading}
                            rowClassName={row => (row.expertId === cursor ? 'store-cursor' : '')}
                            scroll={{
                                x: 1500,
                                ...(tableScrollY != null ? { y: tableScrollY } : {}),
                            }}
                            bordered
                            size="medium"
                            rowSelection={rowSelection}
                            rowKey="expertId"
                            locale={{
                                emptyText: <span style={{ fontSize: 14, color: 'var(--ant-color-text)' }}>请在"会议嘉宾"模块中，为专家标记劳务需求（只有标记为"需要"的专家，才可在本模块申请劳务）</span>,
                            }}
                            pagination={{
                                total,
                                showTotal: () => `共${total}条`,
                                current: filter.page,
                                pageSize: filter.pageSize,
                                showQuickJumper: true,
                                showSizeChanger: { placement: 'topRight' },
                                onChange: onChangePage,
                                pageSizeOptions: TABLE_PAGE_SIZE_OPTIONS,
                                onShowSizeChange,
                            }}
                        />
                    </Form>
                </div>

                {/* 参会凭证预览 Modal */}
                <Modal title="参会凭证" open={!!previewImage} onCancel={() => setPreviewImage(null)} footer={null} centered width={500}>
                    {previewImage && <Image width={300} src={prepareBCOSSUrl(previewImage)} alt="参会凭证" />}
                </Modal>

                <Modal title="提示" open={isModalOpen} onOk={handleOk} okText="发送" centered width={600} onCancel={handleCancel} className="sendForm">
                    <Form labelCol={{ span: 4 }} wrapperCol={{ span: 19 }} name="sendForm" form={sendForm} size="large" autoComplete="off">
                        <div style={{ marginBottom: '40px' }}>
                            说明：点击“发送【确认劳务信息】任务”后，将给当前列表中所有嘉宾发送实际日程的确认任务，嘉宾可在【我的项目】中收到1条【确认劳务信息】的任务，便于嘉宾核实实际日程（嘉宾可点击“我有疑问”或“确认实际日程”）。您可在下方添加联系人姓名和联系电话，便于嘉宾点击“我有疑问”后弹窗展示并联络该联系人，以便双方校对核实实际日程是否有出入。
                        </div>
                        <Form.Item name="agendaConfirmContactsName" label="联系人姓名" rules={[{ required: true }]}>
                            <Input placeholder="请输入联系人姓名" maxLength={30} />
                        </Form.Item>
                        <Form.Item
                            name="agendaConfirmContactsPhone"
                            label="联系电话"
                            rules={[
                                { required: true, message: '请输入联系电话' },
                                { pattern: /^1\d{10}$/, message: '请输入正确的联系电话' },
                            ]}
                        >
                            <Input placeholder="请输入联系电话" maxLength={11} />
                        </Form.Item>
                    </Form>
                </Modal>

                <Modal
                    title="上传参会凭证"
                    open={openCertificate}
                    destroyOnHidden={true}
                    centered
                    width={600}
                    mask={{ closable: false }}
                    onCancel={handleCancelCertificate}
                    footer={
                        <div style={{ textAlign: 'right' }}>
                            <Space>
                                <Button onClick={handleCancelCertificate}>取消</Button>
                                <Button type="primary" htmlType="submit" onClick={handleAddCertificate}>
                                    确定
                                </Button>
                            </Space>
                        </div>
                    }
                >
                    <Form form={uploadForm} layout="vertical" {...pageFormItemLayout}>
                        <Form.Item name="userName" label="专家姓名">
                            <span>{expertName}</span>
                        </Form.Item>
                        <Form.Item name="joinCert" label="参会凭证" help="支持JPG/PNG格式，文件大小不超过10MB">
                            {joinCertList?.length > 0 && (
                                <div className="labor-certificate" style={{ marginBottom: 8 }}>
                                    <Image width={200} height={200} src={joinCertList[0]} alt="参会凭证预览" />
                                    <span onClick={deleteImg} className="close-img">
                                        <i className="bi bi-x"></i>
                                    </span>
                                </div>
                            )}

                            <Upload beforeUpload={file => checkImgUploadFile(file, 10)} fileList={[]} customRequest={fileInfo => uploadImageFile(fileInfo, 'joinCert')}>
                                <Button
                                    icon={
                                        <span className="anticon">
                                            <i className="bi bi-upload" />
                                        </span>
                                    }
                                >
                                    {joinCertList && joinCertList.length > 0 ? '更改凭证' : '上传凭证'}
                                </Button>
                            </Upload>
                        </Form.Item>
                    </Form>
                </Modal>

                <ChooseExpertModal openChooseExpertModal={openChooseExpertModal} setOpenChooseExpertModal={setOpenChooseExpertModal} chooseExpertIds={chooseExpertIds} setChooseExpertIds={setChooseExpertIds} />

                <ConfirmScheduleModal openConfirmScheduleModal={openConfirmScheduleModal} setOpenConfirmScheduleModal={setOpenConfirmScheduleModal} expertId={selectExpertId} updateList={getList} />

                <ConfirmBankInfoModal openConfirmBankInfoModal={openConfirmBankInfoModal} setOpenConfirmBankInfoModal={setOpenConfirmBankInfoModal} expertId={selectExpertId} updateList={getList} />

                {/* 劳务需求备注弹窗 */}
                <Modal
                    title="劳务需求备注"
                    open={demandRemarksModalVisible}
                    onCancel={handleCancelDemandRemarks}
                    footer={[
                        <Button key="cancel" onClick={handleCancelDemandRemarks}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={handleSubmitDemandRemarks}>
                            确认
                        </Button>,
                    ]}
                    width={600}
                    centered
                    mask={{ closable: false }}
                >
                    <div style={{ marginBottom: 8, color: '#888' }}>填写劳务费支付主体要求、支付金额要求等备注信息</div>
                    <Form form={demandRemarksForm} layout="vertical">
                        <Form.Item name="remarks" rules={[{ max: 200, message: '备注内容不能超过200个字符' }]}>
                            <Input.TextArea placeholder="请填写备注内容" rows={6} maxLength={200} showCount />
                        </Form.Item>
                    </Form>
                </Modal>
            </div>

            {conferenceId && <OperationLogDrawer open={openRecordDrawer} onClose={() => setOpenRecordDrawer(false)} entityType="conference" entityId={conferenceId} module="laborfee" />}

            <PaymentBatchDrawer
                isOpen={openPaymentBatchDrawer}
                onClose={onCloseBatchDrawer}
                onApprovalFlowComplete={onApprovalFlowComplete}
                conferenceId={conferenceId}
                laborFeeData={data}
                filter={filter}
                defaultColumns={columns}
                onFormFinish={onFormFinish}
                onReset={onReset}
                onChangePage={onChangePage}
                conference={conference}
                statisticalAmount={statisticalAmount}
                selectedBatchNo={selectedBatchNo}
                getAmountStat={getAmountStat}
                onInvalidSuccess={laborFeeRequestBatchesList}
            />
        </div>
    );
};

export default ConferenceLaborFeeRecords;
